import { css } from "@emotion/core";
import styled from "@emotion/styled";
import React from "react";

import sitemap from "../content/sitemap.yaml";
import Link from "./Link";
import Spacer from "./Spacer";

const { sections /* social, fineprint */ } = sitemap;

const List = styled.ul`
  list-style: none;
  /* margin: 0 4rem; */
  width: 20%;
  padding: 0;

  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }

  @media only screen and (max-width: 520px) {
    width: 25%;
  }
`;

const ListItem = styled.li`
  font-size: 1.25rem;
  color: #444;

  margin-bottom: 1.375rem;

  &:first-of-type {
    font-weight: 500;
    color: #000;
  }

  & a {
    color: #444;

    :hover {
      color: var(--highlight-color);
    }
  }
`;

const Footer = () => (
  <footer>
    <Spacer rem={3} />
    <div
      css={css`
        display: flex;
        justify-content: flex-start;
      `}
    >
      {sections.map(({ name, items }) => (
        <List key={name}>
          <ListItem key={name}>{name}</ListItem>
          {items.map(({ name, href, external }) => (
            <ListItem key={name}>
              <Link external={external} to={href}>
                {name}
              </Link>
            </ListItem>
          ))}
        </List>
      ))}
    </div>

    <Spacer rem={6} />

    <div>
      <p
        css={css`
          font-size: 1.25rem;
          color: rgba(0, 0, 0, 0.4);
        `}
      >
        © {new Date().getFullYear()} Flexa Inc.
        <span
          css={css`
            margin: 0 1.25rem;
          `}
        >
          •
        </span>
        <Link
          css={css`
            color: rgba(0, 0, 0, 0.4);
            &:hover {
              color: rgba(0, 0, 0, 0.5);
            }
          `}
          to="/legal/licenses"
        >
          NMLS ID 1840599
        </Link>
        <span
          css={css`
            margin: 0 1.25rem;
          `}
        >
          •
        </span>
        <Link
          css={css`
            color: rgba(0, 0, 0, 0.4);
            &:hover {
              color: rgba(0, 0, 0, 0.5);
            }
          `}
          to="/privacy"
        >
          Privacy & terms
        </Link>
      </p>
    </div>

    <Spacer rem={2} />
  </footer>
);

export default Footer;
